const API_URL = process.env.REACT_APP_API_URL;
const CHANNEL_PLUGIN_KEY = process.env.REACT_APP_CHANNEL_IO_PLUGIN_KEY;

export { API_URL, CHANNEL_PLUGIN_KEY };
